module.exports = __webpack_public_path__ + "static/media/intimacy.8b281709.svg";